import { eventBus } from './EventBus.js';

document.addEventListener('DOMContentLoaded', () => {
        // Drawer toggle logic
    const dashboard = document.getElementById('dashboard');
    const drawerTab = document.getElementById('drawerTab');
    const tabIcon = drawerTab.querySelector('.tab-icon');
    
    function toggleDrawer() {
        const isCurrentlyOpen = dashboard.classList.contains('open');
        
        if (isCurrentlyOpen) {
            // Close it
            dashboard.classList.remove('open');
            dashboard.classList.add('closed');
            tabIcon.textContent = '<'; // Point left: "click to open"
            eventBus.emit('drawer:closed');
        } else {
            // Open it
            dashboard.classList.remove('closed');
            dashboard.classList.add('open');
            tabIcon.textContent = '>'; // Point right: "click to close"
            eventBus.emit('drawer:opened');
        }
        
        console.log('Dashboard:', isCurrentlyOpen ? 'closed' : 'opened');
    }
    
    // Click tab to toggle
    drawerTab.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleDrawer();
    });
    
    
    // Touch/swipe support for mobile
    let touchStartX = 0;
    const SWIPE_THRESHOLD = 50;
    
    dashboard.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    }, { passive: true });
    
    dashboard.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const deltaX = touchEndX - touchStartX;
        const isOpen = dashboard.classList.contains('open');
        
        // Swipe left on open drawer = close
        if (isOpen && deltaX < -SWIPE_THRESHOLD) {
            toggleDrawer();
        }
        // Swipe right on closed drawer = open  
        else if (!isOpen && deltaX > SWIPE_THRESHOLD) {
            toggleDrawer();
        }
    });
    
    // Keyboard shortcut: [ to toggle
    document.addEventListener('keydown', (e) => {
        if (e.key === '[') toggleDrawer();
    });
    
    // Initialize icon state based on default class
    if (dashboard.classList.contains('open')) {
        tabIcon.textContent = '>';
    } else {
        tabIcon.textContent = '<';
    }

        // Mobile: Force closed on load (desktop stays open)
    if (window.innerWidth <= 768) {
        dashboard.classList.remove('open');
        dashboard.classList.add('closed');
        tabIcon.textContent = '<';
    }

    // Tab switching
    document.querySelectorAll('.tab-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('.tab-btn, .tab-content').forEach(el => el.classList.remove('active'));
            btn.classList.add('active');
            document.getElementById(`${btn.dataset.tab}-tab`).classList.add('active');
        });
    });
    
    // X-Ray toggle
    const xrayToggle = document.getElementById('xray-toggle');
        if (xrayToggle) {
            xrayToggle.addEventListener('click', () => {
                const isActive = xrayToggle.classList.toggle('active');
                eventBus.emit('xray:toggle', isActive);
                console.log('X-Ray mode:', isActive ? 'ON' : 'OFF');
            });
        }

        // Update the xray:stateChanged listener to sync the toggle visual:
        eventBus.on('xray:stateChanged', (isActive) => {
            const toggle = document.getElementById('xray-toggle');
            if (toggle) {
                if (isActive) {
                    toggle.classList.add('active');
                } else {
                    toggle.classList.remove('active');
                }
            }
        });

    // Label toggle
    const labelsToggle = document.getElementById('labels-toggle');
    if (labelsToggle) {
        labelsToggle.addEventListener('click', () => {
            const isActive = labelsToggle.classList.toggle('active');
            eventBus.emit('labels:toggle', isActive);
            console.log('Labels persistent mode:', isActive ? 'ON' : 'OFF');
        });
    }
    
    // Camera buttons
    document.getElementById('btn-topdown').addEventListener('click', () => {
        eventBus.emit('camera:topdown');
        document.getElementById('view-status').textContent = 'Top Down';
    });
    
    document.getElementById('btn-reset').addEventListener('click', () => {
        eventBus.emit('camera:reset');
        document.getElementById('view-status').textContent = 'Overview';
    });

    // Fire simulation buttons
    const btnFireSim = document.getElementById('btn-fire-sim');
    const btnFireReset = document.getElementById('btn-fire-reset');
    const fireStatusBox = document.getElementById('fire-status-box');

    if (btnFireSim) {
        btnFireSim.addEventListener('click', () => {
            eventBus.emit('fire:simulate'); // No parameter needed
            btnFireSim.disabled = true;
            btnFireReset.disabled = false;
            if (fireStatusBox) fireStatusBox.style.display = 'block';
        });
    }

    if (btnFireReset) {
        btnFireReset.addEventListener('click', () => {
            eventBus.emit('fire:reset');
            btnFireSim.disabled = false;
            btnFireReset.disabled = true;
            if (fireStatusBox) fireStatusBox.style.display = 'none';
        });
    }

    // Listen for fire status updates
    eventBus.on('fire:status', (data) => {
        const activeAlarmsEl = document.getElementById('active-alarms');
        if (activeAlarmsEl) {
            activeAlarmsEl.textContent = data.count;
        }
    });

    // Listen for X-ray state changes
    eventBus.on('xray:stateChanged', (isActive) => {
        const checkbox = document.getElementById('xray-toggle');
        if (checkbox) {
            checkbox.checked = isActive;
        }
    });
    
    // Device card generator
    function createDeviceCard(device) {
    const baseState = device.state === 'offline' ? 'offline' : 
              device.state === 'alarm' ? 'alarm' : 
              device.state === 'test' ? 'test' : 'online';
        const batteryClass = (device.battery <= 20 && device.state === 'online') ? 'low-battery' : '';
        const stateClass = `${baseState} ${batteryClass}`.trim();
        
        // When offline, force signal to show "offline" with 3 grey dots
        const isOffline = device.state === 'offline';
        const displaySignal = isOffline ? 'offline' : device.signal;
        
        const signalDots = Array(3).fill(0).map((_, i) => {
            let dotClass = 'offline'; // Default to grey for offline state
            if (!isOffline) {
                if (device.signal === 'strong') {
                    dotClass = 'active';  // All 3 green
                } else if (device.signal === 'fair') {
                    if (i >= 1) dotClass = 'fair';  // Grey, amber, amber
                    else dotClass = ''; // First one grey (no class = default grey from CSS)
                } else if (device.signal === 'weak') {
                    if (i === 2) dotClass = 'weak';  // Grey, grey, red
                    else dotClass = ''; // First two grey
                }
            }
            return `<div class="dot ${dotClass}"></div>`;
        }).join('');
        
        const volumeIcon = device.muted 
    ? '<img src="./icons/icon_mute.svg" class="icon-volume" alt="muted">' 
    : '<img src="./icons/icon_volume.svg" class="icon-volume" alt="unmuted">';
        const footerText = device.state === 'alarm' ? 'ALARM TRIGGERED' : 
                          device.state === 'offline' ? 'Offline' :
                          `Last Test: ${device.lastTest} days ago`;
        
        return `
        <div class="device-card ${stateClass}" data-device-id="${device.id}">
            <div class="card-header">
                <div class="card-title">
                    <div class="device-id">${device.id}</div>
                    <div class="device-location">${device.location}</div>
                </div>
                <div class="signal-indicator">
                    <div class="signal-dots">${signalDots}</div>
                    <span>${displaySignal}</span>
                </div>
            </div>
            
            <div class="card-image">
                ${(() => {
                    const imageMap = {
                        'standard': './img/sensor_a.webp',
                        'smart': './img/sensor_b.webp'
                    };
                    return `<img src="${imageMap[device.type] || './img/sensor_a.png'}" alt="${device.type}">`;
                })()}
            </div>
            
            <div class="card-stats">
                <div class="stat-item">
                    ${device.state === 'offline' ? `
                        <div class="battery-offline">--</div>
                    ` : `
                        <div class="battery-ring" style="--battery: ${device.battery};">
                            <svg viewBox="0 0 44 44">
                                <circle class="battery-bg" cx="22" cy="22" r="18"></circle>
                                <circle class="battery-fill" cx="22" cy="22" r="18"></circle>
                            </svg>
                            <span class="battery-text">${device.battery}%</span>
                        </div>
                    `}
                    <span class="stat-label">Battery</span>
                </div>
                
                <div class="stat-item">
                    <button class="power-btn"><img src="./icons/icon_power.svg" class="icon-power" alt="power"></button>
                    <span class="stat-label">Power</span>
                </div>
                
                <div class="stat-item">
                    <span class="stat-value">${volumeIcon}</span>
                    <span class="stat-label">Volume</span>
                </div>
                
                <div class="stat-item">
                    <span class="stat-value smoke-value">${device.smoke}%</span>
                    <span class="stat-label">Smoke</span>
                </div>
            </div>
            
            <div class="card-footer">
                <span class="footer-text">${footerText}</span>
                <button class="test-btn" ${device.state === 'offline' ? 'disabled' : ''} data-device-id="${device.id}">Test</button>
            </div>
        </div>
        `;
    }

    eventBus.on('devices:loaded', (devices) => {
        const grid = document.getElementById('device-list');
        grid.innerHTML = devices.map(createDeviceCard).join('');
        document.getElementById('detector-count').textContent = devices.length;

        // ADD THIS: Wire up power buttons after cards are in DOM
        grid.querySelectorAll('.power-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation(); // Prevent card selection if you add that later
                const card = btn.closest('.device-card');
                const deviceId = card.dataset.deviceId;

                // Emit event to DeviceManager
                eventBus.emit('device:toggle', deviceId);
            });
        });

        // Wire up volume icons
        grid.querySelectorAll('.icon-volume').forEach(icon => {
            icon.addEventListener('click', (e) => {
                e.stopPropagation();
                const card = icon.closest('.device-card');
                const deviceId = card.dataset.deviceId;
                eventBus.emit('device:toggleMute', deviceId);
            });
        });

        // Wire up test buttons
        grid.querySelectorAll('.card-footer .test-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const deviceId = btn.dataset.deviceId;
                console.log('Test button clicked:', deviceId);
                eventBus.emit('device:test', deviceId);
            });
        });
    });

    // Listen for device state updates
    eventBus.on('device:updated', (device) => {
        const card = document.querySelector(`[data-device-id="${device.id}"]`);
        if (!card) return;

        // Update CSS class - include test state
        const batteryClass = (device.battery <= 20 && device.state !== 'offline') ? 'low-battery' : '';
        card.className = `device-card ${device.state} ${batteryClass}`.trim();

         // Update smoke level
        const smokeValue = card.querySelector('.smoke-value');
        if (smokeValue) {
            smokeValue.textContent = device.smoke + '%';
        }

        // Update footer text
        const footerText = card.querySelector('.footer-text');
        if (footerText) {
            if (device.state === 'test') {
                footerText.textContent = 'TESTING';
            } else if (device.state === 'alarm') {
                footerText.textContent = 'ALARM TRIGGERED';
            } else if (device.state === 'offline') {
                footerText.textContent = 'Offline';
            } else {
                footerText.textContent = `Last Test: ${device.lastTest} days ago`;
            }
        }

        // Update Test button disabled state based on new state
        const testBtn = card.querySelector('.test-btn');
        if (testBtn) {
            testBtn.disabled = device.state === 'offline';
        }

        // Update power button color
        const powerBtn = card.querySelector('.power-btn');
        if (powerBtn) {
            if (device.state === 'offline') {
                powerBtn.style.background = '#ef4444'; // Red when off
            } else {
                powerBtn.style.background = 'rgba(255,255,255,0.2)'; // Normal when on
            }
        }
        
        // Update battery display (switch between ring and --)
        const batteryStat = card.querySelector('.stat-item:first-child');
        if (batteryStat) {
            if (device.state === 'offline') {
                batteryStat.innerHTML = `
                    <div class="battery-offline">--</div>
                    <span class="stat-label">Battery</span>
                `;
            } else {
                const isLowBattery = device.battery <= 20;
                batteryStat.innerHTML = `
                    <div class="battery-ring ${isLowBattery ? 'low-battery' : ''}" style="--battery: ${device.battery};">
                        <svg viewBox="0 0 44 44">
                            <circle class="battery-bg" cx="22" cy="22" r="18"></circle>
                            <circle class="battery-fill" cx="22" cy="22" r="18"></circle>
                        </svg>
                        <span class="battery-text">${device.battery}%</span>
                    </div>
                    <span class="stat-label">Battery</span>`;
            }
        }

        // Update volume icon
        const volumeIcon = card.querySelector('.icon-volume');
        if (volumeIcon) {
            volumeIcon.src = device.muted 
                ? './icons/icon_mute.svg' 
                : './icons/icon_volume.svg';
            volumeIcon.alt = device.muted ? 'muted' : 'unmuted';
        }

        // Update signal indicator when going offline/online
        const signalIndicator = card.querySelector('.signal-indicator');
        if (signalIndicator) {
            const isNowOffline = device.state === 'offline';
            const newSignalText = isNowOffline ? 'offline' : device.signal;
            
            // Update text
            signalIndicator.querySelector('span').textContent = newSignalText;
            
            // Update dots
            const dots = signalIndicator.querySelectorAll('.dot');
            dots.forEach((dot, i) => {
                dot.className = 'dot'; // Reset
                if (isNowOffline) {
                    dot.classList.add('offline'); // All grey
                } else {
                    if (device.signal === 'strong') {
                        dot.classList.add('active');
                    } else if (device.signal === 'fair' && i >= 1) {
                        dot.classList.add('fair');
                    } else if (device.signal === 'weak' && i === 2) {
                        dot.classList.add('weak');
                    }
                }
            });
        }
    });
});